module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAEFJREFUeNpi/P//PwMpgImBRDBUNHC3f2vm7vj+EEQTZwMjY5wAB9sJEE2chv//F3348cuC4T/jIgyzhkE8AAQYAEMKFZRz0k1qAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/5.png
// module id = Bz3C
// module chunks = 1